<template>
  <svg class="app-icon" :class="{ 'web-assistant': isWebAssistant }">
    <use xmlns:xlink="http://www.w3.org/1999/xlink" :xlink:href="`#${logo}`"></use>
  </svg>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

const props = defineProps({
  channelType: {
    type: String,
    required: true,
  },
});

const logo = computed(() => {
  switch (props.channelType) {
    case 'sms-bt':
      return 'bt';
    case 'sms-govuknotify':
      return 'govuk-crown';
    case 'messenger':
      return 'fb-messenger';
    case 'twitter-dm':
      return 'twitter';
    case 'instagram':
      return 'instagram';
    case 'whatsapp':
      return 'whatsapp';
    case 'google-bm':
      return 'google-bm';
    default:
      return 'web-assistant';
  }
});

const isWebAssistant = computed(() => props.channelType === 'web-assistant');
</script>

<style scoped lang="scss">
svg {
  &.web-assistant {
    fill: $color-netcall-deep-sea;
  }
}
</style>
